import { SRP_TYPES } from './SRPTypes.definitions';

export function getSRPType(filters, searchData, categoriesParam, searchTerm) {
  //https://tradetracker.atlassian.net/browse/MIAB-3586
  //page_title should be used in h1 as is
  if (searchData?.page_title?.trim()) return SRP_TYPES.API_OVERRIDE;

  const isSingleBrandSelected = Array.isArray(filters?.brands) && filters?.brands.length === 1;
  const singleBrandName = isSingleBrandSelected ? filters?.brands[0] : null;
  //https://tradetracker.atlassian.net/browse/MIAB-4116
  //aplicable if query is empty, single_brand and category are selected
  if (!searchTerm && singleBrandName && categoriesParam) return SRP_TYPES.BRAND;

  if (searchTerm === 'korting') return SRP_TYPES.DISCOUNTS;

  return SRP_TYPES.DEFAULT;
}
